import en from './en';
import fr from './fr';
import hi from './hi';
import de from './de';


const locale = {
    ...en,
    ...fr,
    ...hi,
    ...de
}

export default locale;